var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('target-list'),_c('history-list',{staticStyle:{"margin-top":"16px"},attrs:{"hasNoFunctions":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }